import { combineReducers } from 'redux';
import orderReducer from './orderReducer';

const reducer = combineReducers({
  orders: orderReducer,
});

export default reducer;
